<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';


export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

        payload.getServices();
        payload.getUserTypes();
        payload.getAdditionalResources();

        
    },
    methods:{
        save: function(){
            this.errors = [];
            this.messageIdToast = null;

            let data = JSON.parse(JSON.stringify(this.data));

            if (data.setupPrice){
                data.setupPrice = data.setupPrice.toString().split('.').join('').split(',').join('.').split('R$ ').join('');
            }
            if (data.monthlyPrice){
                data.monthlyPrice = data.monthlyPrice.toString().split('.').join('').split(',').join('.').split('R$ ').join('');
            }



            if(data.additionalResources && data.additionalResources.length > 0){
                let copyAdditionalResources = data.additionalResources;
                let additionalResources = [];
                for(let i=0; i< copyAdditionalResources.length; i++){
                    if(copyAdditionalResources[i] && copyAdditionalResources[i]._id)
                        additionalResources.push(copyAdditionalResources[i]._id);
                }
                data.additionalResources = additionalResources;
            }

            if(data.userTypes && data.userTypes.length > 0){
                let copyUserTypes = data.userTypes;
                console.log(JSON.stringify(copyUserTypes))

                let userTypes = [];
                let dataForm = {
                    user: null,
                    quantity: null,
                };
                for(let i=0; i< copyUserTypes.length; i++){
                    if(copyUserTypes[i] && copyUserTypes[i].user._id){
                        dataForm.user = copyUserTypes[i].user._id;
                        dataForm.quantity = copyUserTypes[i].quantity;
                        userTypes.push(JSON.parse(JSON.stringify(dataForm)));
                    }
                }
                data.userTypes = userTypes;
            }   
            console.log(JSON.stringify(data.userTypes))
            Request.do(this, this.data._id ? 'PUT' : 'POST', Request.getDefaultHeader(this), data, `${Endpoints.plans.plan}${this.data._id ? this.data._id : ''}`,
                (companyResponse)=>{//SUCCESS CALLBACK
                    this.$fire({
                        text: this.data._id ? this.$t('str.register.put.sucess') : this.$t('str.register.saved.sucess'),
                        type: "success",
                        timer: 2000
                        }).then(() => {
                        this.errors = [];
                    });
                },
                (error)=>{//ERROR CALLBACK
                    let res = error.response;
                    if (res.status == 500){
                        this.titleToast = this.$t('parresia.msg.toast.advice');
                        
                        if (res.data.messageId === 'parresia.already.exists'){
                            this.messageToast = this.$t('parresia.company.register.error.element.exists');
                        }else if (res.data.messageId === 'parresia.msg.error.required.fields'){
                            this.messageToast = this.$t('parresia.msg.error.required.fields');
                        }else{
                            this.messageToast = this.$t('parresia.msg.error.generic');
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
            });     
        },
        removeTypeUser(index){
            if(index > -1){
                this.data.userTypes.splice(index, 1);
            }
        },
        addUser: function(user, quantity){
            if(user && quantity && quantity > 0){
                let data = JSON.parse(JSON.stringify({user: user, quantity: quantity}));
                let index = this.data.userTypes.findIndex(x => x.user._id == user._id);
                if(index > -1){
                    this.data.userTypes.splice(index, 1);
                    this.data.userTypes.push(data);
                    this.quantity = null;
                }else{
                    this.data.userTypes.push(data);
                    this.quantity = null;
                }
            }
        },
        isAdminMaster: function(){
            let user = this.$session.get('user');
            if (user){
                return user.companyUser && user.companyUser.subtype == "ADMIN_MASTER";
            }
            return false;
        },
        getServices: function(){
            //################### LOAD SERVICE TYPES
            Request.do(this, 'GET', Request.getDefaultHeader(this), null, `${Endpoints.services.active}`,
            (response)=>{//SUCCESS CALLBACK
                this.services = response.results;
            },
            (error)=>{//ERROR CALLBACK
            });
        },
        getUserTypes: function(){
            //################### LOAD USER TYPES
            Request.do(this, 'GET', Request.getDefaultHeader(this), null, `${Endpoints.systemUsers.typeUser}`,
            (response)=>{//SUCCESS CALLBACK
                this.userTypes = response.results;
            },
            (error)=>{//ERROR CALLBACK
            });
        },
        getAdditionalResources: function(){
            //################### LOAD RESOURCES
            Request.do(this, 'GET', Request.getDefaultHeader(this), null, `${Endpoints.companies.listResources}`,
            (response)=>{//SUCCESS CALLBACK
                this.additionalResources = response.results;
            },
            (error)=>{//ERROR CALLBACK
            });
        },
        handleFileUpload(){
            this.file = this.$refs.file.files[0];
        },
        clearForm: function(){
            this.errors = [];
            this.data =  {}
        },
        checkForm: function (e) {

            this.errors = [];
            if (!this.data.name) {
                this.errors.push(this.$t('response.plans.register.name.required'));
            }
            if (!this.data.platforms) {
                this.errors.push(this.$t('response.plans.register.platforms.required'));
            }
            
            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.save();
            }
        },
        archive: function(response){
            if (response==1){

                this.errors = [];
                this.messageIdToast = null;
                let state = this;
                Request.do(this, 'DELETE', Request.getDefaultHeader(this), this.data, `${Endpoints.plans.plan}${this.data._id ? this.data._id : ''}`,
                    (companyResponse)=>{//SUCCESS CALLBACK
                        this.$fire({
                            text: this.$t('str.archive.put.sucess'),
                            type: "success",
                            timer: 2000
                            }).then(r => {
                                 this.clearForm();
                        });
             
                    },
                    (error)=>{//ERROR CALLBACK
                
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                });
            }
        },
        confirmArchive: function(item){
            this.titleToast = this.$t("string.msg.confirm");
            this.messageToast = this.$t("response.archive.plans.confirmation");
            this.cancelText = this.$t("string.msg.cancel");
            this.yesText = this.$t("string.msg.yes");
            $('#confirmationPlans').modal('show');
        },
        selectItem: function(item){
            this.errors = [];
            this.data = JSON.parse(JSON.stringify(item));

            if(this.data.platforms && this.data.platforms.length > 0){
                let copyPlatforms = this.data.platforms;
                let platforms = [];
                for(let i=0; i< copyPlatforms.length; i++){
                    if(copyPlatforms[i] && copyPlatforms[i]._id)
                        platforms.push(copyPlatforms[i]._id)
                }
                this.data.platforms = platforms;
            }

            // if(this.data.userTypes && this.data.userTypes.length > 0){
            //     let copyUserTypes = this.data.userTypes;
            //     let userTypes = [];
            //     for(let i=0; i< copyUserTypes.length; i++){
            //         if(copyUserTypes[i] && copyUserTypes[i]._id)
            //             userTypes.push(copyUserTypes[i]._id)
            //     }
            //     this.data.userTypes = userTypes;
            // }

            // if(this.data.AdditionalResources && this.data.AdditionalResources.length > 0){
            //     let copyAdditionalResources = this.data.AdditionalResources;
            //     let AdditionalResources = [];
            //     for(let i=0; i< copyAdditionalResources.length; i++){
            //         if(copyAdditionalResources[i] && copyAdditionalResources[i]._id)
            //             AdditionalResources.push(copyAdditionalResources[i]._id)
            //     }
            //     this.data.AdditionalResources = AdditionalResources;
            // }

            if(this.data.setupPrice){
                this.data.setupPrice = this.data.setupPrice.toFixed(2);
            }
            if(this.data.monthlyPrice){
                this.data.monthlyPrice = this.data.monthlyPrice.toFixed(2);
            }

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        customLabelUserTypes(option) {
            return `${option.name}`
        },
        customLabelAdditionalResources(option) {
            return `${option.name}`
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }

}
</script>